var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.918945C9.87978 0.918961 9.76075 0.943828 9.64981 0.992104C9.53887 1.04038 9.43822 1.11111 9.35369 1.2002L0.184659 9.53778C0.127395 9.58181 0.0808519 9.63924 0.0487785 9.70545C0.0167051 9.77165 -2.73427e-06 9.84478 3.35629e-10 9.91895C3.35629e-10 10.0446 0.0478895 10.1651 0.133133 10.2539C0.218377 10.3427 0.333993 10.3926 0.454545 10.3926H2.72727V17.9716C2.72727 18.4945 3.13455 18.9189 3.63636 18.9189H7.27273C7.77455 18.9189 8.18182 18.4945 8.18182 17.9716V12.2874H11.8182V17.9716C11.8182 18.4945 12.2255 18.9189 12.7273 18.9189H16.3636C16.8655 18.9189 17.2727 18.4945 17.2727 17.9716V10.3926H19.5455C19.666 10.3926 19.7816 10.3427 19.8669 10.2539C19.9521 10.1651 20 10.0446 20 9.91895C20 9.84478 19.9833 9.77165 19.9512 9.70545C19.9191 9.63924 19.8726 9.58181 19.8153 9.53778L10.6516 1.20575C10.6499 1.20389 10.6481 1.20204 10.6463 1.2002C10.5618 1.11111 10.4611 1.04038 10.3502 0.992104C10.2392 0.943828 10.1202 0.918961 10 0.918945Z",
    fill: "black",
    fillOpacity: 0.54
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecent);
export default __webpack_public_path__ + "static/media/Recent.161995545360d45498fb4080c46df825.svg";
export { ForwardRef as ReactComponent };